import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import WithPaymentHome from "../views/WithPaymentHome.vue";
import RedirectHome from "../views/RedirectHome.vue";
import paymentPortal from "../views/paymentPortal";
import paymentPortalV3 from '../views/paymentPortalV3.vue';
import PaymentSuccess from "../views/PaymentSuccess";
import PaymentFail from "../views/PaymentFail";
import PaymmentWithContentCategory from "../views/PaymentWithContentCategory.vue";
import CheckPaymentStatus from "../views/CheckPaymentStatus.vue";
import PaymentCancel from "../views/PaymentCancel.vue";
import OrderByCategory from "../views/OrderByCategory.vue";
import newyearOrder from "../views/newyearOrder.vue";
import NewYearBaydin from "../views/NewYearBaydin";
import OrderDetail from "../views/OrderDetail";
import Tarot from "../views/Tarot";
import SpecialOffer from "../views/SpecialOffer.vue";
import Nawin from "../views/Nawin";
import Clairvoyance from '../views/Clairvoyance';
import TarotShuffleForm from '../views/TarotShuffleForm';
import CompatabilityLoveForm from '../views/CompatabilityLoveForm';
import TarotShuffle from '../views/TarotShuffle';
import CompatabilityLove from '../views/CompatabilityLove';
import OnePayRedirect from '../views/OnePayRedirect';
import Questions from '../views/Questions';
import Details from "../views/details.vue";
import Answer from "../views/Answer.vue";

Vue.use(VueRouter);

const Normal = () =>
    import(/* webpackChunkName: "about" */ "../views/Normal.vue");
const Content = () =>
    import(/* webpackChunkName: "about" */ "../views/Content.vue");
const Special = () =>
    import(/* webpackChunkName: "about" */ "../views/Special.vue");
const Direct = () =>
    import(/* webpackChunkName: "about" */ "../views/Direct.vue");
const Phone = () =>
    import(/* webpackChunkName: "about" */ "../views/Phone.vue");
const Order = () =>
    import(/* webpackChunkName: "about" */ "../views/Order.vue");
const Category = () =>
    import(/* webpackChunkName: "about" */ "../views/Category.vue");
const Free = () => import(/* webpackChunkName: "about" */ "../views/Free.vue");
const Orders = () =>
    import(/* webpackChunkName: "about" */ "../views/Orders.vue");
const Star = () => import(/* webpackChunkName: "about" */ "../views/Star.vue");
const Zoom = () => import(/* webpackChunkName: "about" */ "../views/Zoom.vue");
const BaydinSayar = () =>
    import(/* webpackChunkName: "about" */ "../views/BaydinSayar.vue");

const routes = [
    // {
    //     path: "/*",
    //     name: "Service Maintain",
    //     component: ServiceMaintain
    // },
    {
        path: "/compatability-love-form",
        name: "Compatability Love Form",
        component: CompatabilityLoveForm
    },
    {
        path: "/tarot-shuffle-form",
        name: "Tarot Shuffle Form",
        component: TarotShuffleForm
    },
    {
        path: "/tarot-shuffle",
        name: "Tarot Shuffle",
        component: TarotShuffle
    },
    {
        path: "/compatability-love",
        name: "Compatability Love",
        component: CompatabilityLove
    },
    {
        path: "/",
        name: "home",
        component: Home,
    },
    {
        path: "/payment/:payment",
        name: "withPaymenthome",
        component: WithPaymentHome,
    },

    // Onepay redirect
    {
        path: "/onepay-redirect/:data",
        name: "OnePayRedirect",
        component: OnePayRedirect
    },

    // Redirect Payment Portal
    {
        path: "/paymentPortal",
        name: "paymentPortal",
        component: paymentPortal,
    },
    {
        path: "/paymentPortalV3",
        name: "paymentPortalV3",
        component: paymentPortalV3
    },
    // End
    {
        path: "/newyearBaydin",
        name: "NewYearBaydin",
        component: NewYearBaydin,
    },
    {
        path: "/tarot",
        name: "tarot",
        component: Tarot,
    },
        {
        path: "/specialoffer",
        name: "specialoffer",
        component: SpecialOffer,
    },
    {
        path: "/clairvoyance",
        name: "clairvoyance",
        component: Clairvoyance,
    },
    // Redirect component for un exist route
    {
        path: "/PaymentSuccess/:payment",
        name: "PaymentSuccess",
        component: PaymentSuccess,
    },
    {
        path: "/PaymentFail/:payment",
        name: "PaymentFail",
        component: PaymentFail,
    },
    {
        path: "/PaymentCancel/:payment",
        name: "PaymentCancel",
        component: PaymentCancel,
    },
    // end
    {
        path: "/payment",
        name: "RedirectHome",
        component: RedirectHome,
    },
    {
        path: "/normal/:categoryId",
        name: "normal",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: Normal,
    },
    {
        path: "/special/:categoryId",
        name: "special",
        component: Special,
    },
    {
        path: "/direct/:categoryName?",
        name: "direct",
        component: Direct,
    },
    {
        path: "/phone",
        name: "phone",
        component: Phone,
    },
    {
        path: "/content/:categoryId",
        name: "content",
        component: Content,
    },
    {
        path: "/order",
        name: "order",
        component: Order,
    },
    {
        path: "/category/:categoryName",
        name: "category",
        component: Category,
    },
    {
        path: "/free",
        name: "free",
        component: Free,
    },
    {
        path: "/orders",
        name: "orders",
        component: Orders,
    },
    {
        path: "/star/:categoryName",
        name: "star",
        component: Star,
    },
    {
        path: "/zoom/:baydinsayar",
        name: "zoom",
        component: Zoom,
    },
    {
        path: "/baydinsayar",
        name: "baydinsayar",
        component: BaydinSayar,
    },
    {
        path: "/paymentMethodWithContentCategory/:paymentMethod/:contentCategory",
        name: "paymentMethodWithContentCategory",
        component: PaymmentWithContentCategory,
    },
    {
        path: "/paymentStatusManualCheck/:paymentMethod/:merchatRefId",
        name: "paymentStatusManualCheck",
        component: CheckPaymentStatus,
    },
    {
        path: "/order/categorys",
        name: "orderbyCategory",
        component: OrderByCategory,
    },
    {
        path: "/order/newyear",
        name: "newyearOrder",
        component: newyearOrder,
    },
    {
        path: "/orderDetail/:detail",
        name: "orderDetail",
        component: OrderDetail,
    },

    {
        path: "/nawin",
        name: "Nawin",
        component: Nawin,
    },
    {
        path: "/questions",
        name: "Questions",
        component: Questions,
    },
    {
        path: "/orders-details",
        name: "ordersDetails",
        component: Details
    },
    {
        path: "/answer",
        name: "answer",
        component: Answer,
    }
];

const router = new VueRouter({
    // mode: "hash",
    base: process.env.BASE_URL,

    routes,
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || '1875 BayDin';
    const fullUrl = `${window.location.origin}${to.fullPath}`;
    console.log('Navigating to:', fullUrl);

    next();
});

export default router;
